/* PYNRS (Mayra, 2026-11-03): links that leave the store open in a new tab, site-wide.
   Covers menus, footer, sections and anything added later (drawers, filters, quick buy). A link counts as external when
   it is http(s) on another host than this one (www. ignored) and not a Shopify checkout host. Links with their own
   target, a download attribute or data-same-tab are left alone. */
(() => {
  const here = window.location.hostname.replace(/^www\./, '');
  const internalHost = (host) => host === here || host.endsWith('.myshopify.com') || host === 'checkout.shopify.com';

  const isExternal = (link) => {
    if (link.hasAttribute('target') || link.hasAttribute('download') || link.hasAttribute('data-same-tab')) return false;
    const href = link.getAttribute('href');
    if (!href || href.startsWith('#')) return false;
    let url;
    try {
      url = new URL(href, window.location.href);
    } catch (e) {
      return false;
    }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
    return !internalHost(url.hostname.replace(/^www\./, ''));
  };

  const mark = (link) => {
    if (!isExternal(link)) return;
    link.setAttribute('target', '_blank');
    const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
    rel.add('noopener');
    link.setAttribute('rel', [...rel].join(' '));
  };

  const scan = (root) => {
    if (root.nodeType !== 1) return;
    if (root.matches('a[href]')) mark(root);
    root.querySelectorAll('a[href]').forEach(mark);
  };

  const start = () => {
    scan(document.body);
    new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.type === 'attributes') mark(record.target);
        else record.addedNodes.forEach(scan);
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  };

  // last line of defence for links created and clicked before the observer runs
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (link) mark(link);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
